import { render, staticRenderFns } from "./_2.vue?vue&type=template&id=e96a8878&"
import script from "./_2.vue?vue&type=script&lang=js&"
export * from "./_2.vue?vue&type=script&lang=js&"
import style0 from "./_2.vue?vue&type=style&index=0&id=e96a8878&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports